import { forwardRef, Ref } from 'react';
import {
  Select as AntdSelect,
  type SelectProps as AntdSelectProps,
  type RefSelectProps,
} from 'antd';
import classNames from 'classnames';

import './select.scss';

export type SelectProps = AntdSelectProps;

export const Select = forwardRef<RefSelectProps, SelectProps>(
  ({ className, ...props }, ref: Ref<RefSelectProps>) => {
    return (
      <AntdSelect
        {...props}
        ref={ref}
        className={classNames('the5ers-select', className)}
      />
    );
  },
);
